const initializeGoogleAnalytics = () => {
  // Create the gtag function if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  const gtag = (...args) => {
    window.dataLayer.push(args);
  };

  // Initialize gtag (but don't track page view yet)
  gtag('js', new Date());

  // Make gtag available globally
  window.gtag = gtag;
};

// Send page view to Google Analytics
const sendPageView = () => {
  if (typeof window.gtag === 'function' && window.GA_TRACKING_ID) {
    window.gtag('config', window.GA_TRACKING_ID, {
      page_title: document.title, // eslint-disable-line camelcase
      page_location: window.location.href // eslint-disable-line camelcase
    });
  }
};

// Initialize GA and track page views on both initial load and Turbo navigation
document.addEventListener('turbo:load', () => {
  if (window.GA_TRACKING_ID) {
    // Initialize GA if not already initialized
    if (typeof window.gtag !== 'function') {
      initializeGoogleAnalytics();
    }

    // Always send page view (for both initial load and subsequent navigations)
    sendPageView();
  }
});
